require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-poliform-armadale-residence.json") })
        }
      }, "path---journal-poliform-armadale-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-poliform-armadale-residence!./.cache/json/journal-poliform-armadale-residence.json
// module id = 525
// module chunks = 231608221292675